// Copyright (c) 2022 by Move Closer

import { ComputedRef } from '@vue/composition-api'

import { HasSize, UseSizeClassProvides } from '../../composables'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export enum Level {
  Level1 = 1,
  Level2 = 2,
  Level3 = 3,
  Level4 = 4,
  Level5 = 5,
  Level6 = 6
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export interface HeadingProps extends HasSize {
  /**
   * Display plain text.
   */
  content?: string

  /**
   * Decorate heading
   */
  decorator?: string

  /**
   * The level of the heading from 1 to 6.
   */
  level: Level

  /**
   * HTML wrappers that will be applied as HTML child elements.
   */
  wrappers: string[]
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export interface UseCustomHeadingProvides extends UseSizeClassProvides {
  decoratorClass: ComputedRef<string>
  steps: ComputedRef<string[]>
}
